<div class="container-verify">
  <!-- LOGO del progetto -->
  <div class="logo-verify">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="verify-box">
    <!-- Loading State -->
    <div class="verify-content" *ngIf="isLoading">
      <mat-spinner diameter="60"></mat-spinner>
      <h2>{{ 'auth.verify.loading-title' | translate }}</h2>
      <p>{{ 'auth.verify.loading-description' | translate }}</p>
    </div>

    <!-- Success State -->
    <div class="verify-content" *ngIf="!isLoading && isSuccess">
      <div class="icon-container success">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h2>{{ 'auth.verify.success-title' | translate }}</h2>
      <p class="success-message">{{ message }}</p>
      <p>{{ 'auth.verify.success-description' | translate }}</p>
      <button class="btn-primary" (click)="goToLogin()">
        <mat-icon>login</mat-icon>
        <span>{{ 'auth.verify.go-to-login' | translate }}</span>
      </button>
    </div>

    <!-- Error State -->
    <div class="verify-content" *ngIf="!isLoading && !isSuccess">
      <div class="icon-container error">
        <mat-icon>error</mat-icon>
      </div>
      <h2>{{ 'auth.verify.failed-title' | translate }}</h2>
      <p class="error-message">{{ errorMessage }}</p>
      <p>{{ 'auth.verify.failed-description' | translate }}</p>
      <div class="button-group">
        <button class="btn-secondary" (click)="goToResendVerification()">
          <mat-icon>email</mat-icon>
          <span>{{ 'auth.verify.resend' | translate }}</span>
        </button>
        <button class="btn-primary" (click)="goToLogin()">
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'auth.back-to-login' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
